import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { ApiResponse } from '../../../../../core/models/auth.models';
import { PendentDto, RepeatStudyBatchDto, FinishOrderBatchDto, StudyBatchDto, ListDto } from '../../models/dtos/PendentDto';
import { OrderResultDto } from '../../models/dtos/OrderResultDto';

@Injectable({
    providedIn: 'root'
})
export class OrderService {
    private http = inject(HttpClient);
    private apiUrl = environment.apiUrl;
    private headers = new HttpHeaders();

    constructor() {}

    getStudyToken(): { token: string; segundos: number }[] {
        try {
            const nfcToken = localStorage.getItem('nfc_token');
            const segundos = Number(localStorage.getItem('study_seconds')) || 0;

            if (!nfcToken) {
                console.warn('⚠️ No se encontró nfc_token en localStorage');
                return [];
            }

            const tokenData = [{ token: nfcToken, segundos }]; // Usa 20 segundos como en tu relay

            return tokenData;
        } catch (error) {
            console.error('❌ Error al leer nfc_token del localStorage:', error);
            return [];
        }
    }

    SearchOrders(type: string, value?: string, from?: string, to?: string): Observable<ApiResponse<PendentDto[]>> {
        let params: any = { type };
        if (value) params.value = value;
        if (from) params.from = from;
        if (to) params.to = to;

        return this.http.get<ApiResponse<PendentDto[]>>(this.apiUrl + 'orders/search', { params });
    }

    SearchOrdersResult(type: string, value?: string, from?: string, to?: string): Observable<ApiResponse<OrderResultDto[]>> {
        let params: any = { type };
        if (value) params.value = value;
        if (from) params.from = from;
        if (to) params.to = to;

        return this.http.get<ApiResponse<OrderResultDto[]>>(this.apiUrl + 'orders/search', { params });
    }

    getstatus(): Observable<any> {
        const entity = 'ORDER_DETAIL';
        return this.http.get<any>(this.apiUrl + 'settings/catalogs/status/entity/' + entity + '/list', {
            headers: this.headers
        });
    }

    getstatuscab(): Observable<any> {
        const entity = 'ORDER';
        return this.http.get<any>(this.apiUrl + 'settings/catalogs/status/entity/' + entity + '/list', {
            headers: this.headers
        });
    }

    // Nuevo: Repetir estudio
    repeatStudyBatch(dto: RepeatStudyBatchDto): Observable<ApiResponse<any>> {
        const orderDetailId = dto.repeats.map((study) => study.idOrderDetail).join(',');
        const statusIDs = dto.repeats.map((study) => study.idStatus).join(',');
        const reason = dto.repeats.map((study) => study.reason).join(',');
        return this.http.patch<ApiResponse<any>>(this.apiUrl + 'orders/detail/' + orderDetailId + '/replay-status?statusId=' + statusIDs + '&observation=' + reason, { headers: this.headers });
        // /api/v1/arco/orders/detail/{orderDetailId}/replay-status1/replay-status?statusId=1&observation=frfr'
    }

    // Nuevo:  Completar orden
    finishOrderBatch(dto: FinishOrderBatchDto): Observable<ApiResponse<any>> {
        const orderID = dto.orders.map((order) => order.idOrder).join(',');
        const statusIDs = dto.orders.map((order) => order.idStatus).join(',');
        return this.http.patch<ApiResponse<any>>(this.apiUrl + 'orders/' + orderID + '/status?statusId=' + statusIDs, { headers: this.headers });
    }

    orderdetailbatch(dto: StudyBatchDto): Observable<ApiResponse<any>> {
        const orderdetailID = dto.studies.map((study) => study.idOrderDetail).join(',');
        const statusIDs = dto.studies.map((study) => study.idStatus).join(',');
        return this.http.patch<ApiResponse<any>>(this.apiUrl + 'orders/detail/' + orderdetailID + '/status?statusId=' + statusIDs, { headers: this.headers });
    }

    // Método para actualizar el doctor de la orden
    updateOrderDoctor(orderId: number, doctorId: number): Observable<any> {
        const url = `${this.apiUrl}orders/${orderId}/doctor?doctorId=${doctorId}`;
        // const payload = { doctorId: doctorId };
        return this.http.patch(url, { headers: this.headers });
    }

    // Método para actualizar el seguro de la orden
    updateOrderSecure(orderId: number, secureId: number, subsidiaryId?: number): Observable<any> {
        let url = `${this.apiUrl}orders/${orderId}/secure?secureId=${secureId}`;
        if (subsidiaryId) {
            url += `&subsidiaryId=${subsidiaryId}`;
        }
        return this.http.patch(url, { headers: this.headers });
    }

    // Método para crear un doctor
    createDoctor(doctorData: any): Observable<any> {
        const url = `${this.apiUrl}doctors`;
        return this.http.post(url, doctorData, { headers: this.headers });
    }

    SearchOrdersList(type: string, value?: string, from?: string, to?: string): Observable<ApiResponse<ListDto[]>> {
        let params: any = { type };
        if (value) params.value = value;
        if (from) params.from = from;
        if (to) params.to = to;

        return this.http.get<ApiResponse<ListDto[]>>(this.apiUrl + 'orders/searchList', { params });
    }

    getInvoiceByOrder(idOrder: number): Observable<ApiResponse<any>> {
        return this.http.get<ApiResponse<any>>(this.apiUrl + 'invoices/order/' + idOrder, { headers: this.headers });
    }

    getOrderById(orderId: number): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}orders/${orderId}`);
    }
}
